import React from 'react';

export const NotAuthenticated = () => <span id='oidcProvider_loadingComponent'></span>;
